import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'

import { AbilityContext } from '../../../../components/Ability'
import AddressListPage from './Features/AddressList'


const AddressPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('read', 'Setting') ? < AddressListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default AddressPage
